import { Injectable } from '@angular/core';
import { AppNotifyComponent } from './notify.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class AppNotifyService {
  constructor(private _snackBar: MatSnackBar) {}

  success(message: string) {
    this._open(message, 'success');
  }

  error(message: string) {
    this._open(message, 'error');
  }

  private _open(message: string, type?: string) {
    this._snackBar.openFromComponent(AppNotifyComponent, {
      panelClass: 'mat-snack-bar-' + type,
      data: { message: message, type: type },
    });
  }
}
